//
import PropTypes from "prop-types"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    DateListNoFutureFilter,
    StanceFilter,
    PriorityFilter,
    PriorityLastUserFilter,
    StanceLastUserFilter,
} from "shared/search/containers/Filter/Filters"

import {
    DocketAgencyFilter,
    DocketDescriptionFilter,
    DocketDocketIdFilter,
    DocketDocketTypeFilter,
    DocketRegulationFilter,
    DocketTitleFilter,
} from "shared/search/containers/Filter/DocketFilters"

import {
    RegulationDatePickerStartNoFutureFilter,
    RegulationDatePickerEndNoFutureFilter,
} from "shared/search/containers/Filter/RegulationFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const DocketTypeFilterGroup = (props) => genericFilterGroup(props)
DocketTypeFilterGroup.propTypes = defaultPropTypes
DocketTypeFilterGroup.defaultProps = {
    filters: [DocketDocketTypeFilter],
    uniqueFilterGroupId: "docketTypeFilterGroup",
    displayLabel: "Docket Type",
    helpText: "Filter by docket type",
}

export const DocketAssociatedObjectsFilterGroups = (props) => genericFilterGroup(props)
DocketAssociatedObjectsFilterGroups.propTypes = defaultPropTypes
DocketAssociatedObjectsFilterGroups.defaultProps = {
    filters: [DocketRegulationFilter, DocketAgencyFilter],
    uniqueFilterGroupId: "docketAssociatedObjectsFilterGroups",
    displayLabel: "Referencing",
    helpText: "Filter by regulation",
}

export const DocketSearchFilterGroup = (props) => genericFilterGroup(props)
DocketSearchFilterGroup.propTypes = defaultPropTypes
DocketSearchFilterGroup.defaultProps = {
    filters: [DocketTitleFilter, DocketDescriptionFilter, DocketDocketIdFilter],
    uniqueFilterGroupId: "docketSearchFilterGroup",
    displayLabel: "Title & Description",
    helpText: "Search for dockets by their title or description",
}

export const DocketListFilterGroup = (props) => genericFilterGroup(props)
DocketListFilterGroup.propTypes = defaultPropTypes
DocketListFilterGroup.defaultProps = {
    filters: [
        createListFilter(DjangIO.app.models.QuorumDataType.docket.value),
        createNotInListFilter(DjangIO.app.models.QuorumDataType.docket.value),
        ManuallyChangedInListFilter,
    ],
    uniqueFilterGroupId: "docketListFilterGroup",
    displayLabel: "Lists",
    helpText: "Filter dockets by your lists to show dockets you've saved to Projects.",
}

export const DocketStanceFilterGroup = (props) => genericFilterGroup(props)
DocketStanceFilterGroup.propTypes = defaultPropTypes
DocketStanceFilterGroup.defaultProps = {
    filters: [StanceFilter, StanceLastUserFilter],
    uniqueFilterGroupId: "docketStanceFilterGroup",
    displayLabel: "Stance",
    helpText: "Filter dockets by your organization's stance.",
}

export const DocketPriorityFilterGroup = (props) => genericFilterGroup(props)
DocketPriorityFilterGroup.propTypes = defaultPropTypes
DocketPriorityFilterGroup.defaultProps = {
    filters: [PriorityFilter, PriorityLastUserFilter],
    uniqueFilterGroupId: "docketPriorityFilterGroup",
    displayLabel: "Priority",
    helpText: "Filter dockets by your organization's indicated priority.",
}

export const DocketDateFilterGroup = (props) => genericFilterGroup(props)
DocketDateFilterGroup.propTypes = defaultPropTypes
DocketDateFilterGroup.defaultProps = {
    filters: [DateListNoFutureFilter, RegulationDatePickerStartNoFutureFilter, RegulationDatePickerEndNoFutureFilter],
    uniqueFilterGroupId: "docketDateFilterGroup",
    displayLabel: "Date",
    helpText: "Filter for dockets by the date they were created",
}

export const DocketOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "docketOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.docket.value,
})
